export default {
  methods: {
    removeTab(name) {
      let index = this.editableTabs.findIndex(tab => tab.title === name);
      this.editableTabs.splice(index, 1);
      if (this.editableTabs.length) {
        this.activeTab = this.editableTabs[
          index - 1 < 0 ? index : index - 1
        ].title;
      } else {
        if (this.defaultActive) {
          this.activeTab = this.defaultActive;
        } else {
          this.activeTab = "0";
        }
      }
    }
  }
};
